// 设备模板信息api
import request from '@/utils/request'
export const pageListApi = (data) => {
    return request({
        url: 'SkillTasks/List',
        method: 'post',
        data
    })
}

export const detailApi = (data) => {
    return request({
        url: 'SkillTasks/byData',
        method: 'post',
        data
    })
}

export const saveApi = (data) => {
    return request({
        url: 'SkillTasks/save',
        method: 'post',
        data
    })
}

export const setMemberApi = (data) => {
    return request({
        url: 'UserSkillTasks/AddUser',
        method: 'post',
        data
    })
}
